import type { LucideIcon } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { Icone } from './Icone.js'

/**
 * Tom de voz do guia: "Fala direto, com animação e como alguém do bairro.
 * Frases curtas." Daí o texto padrão não ser "Nenhum resultado encontrado".
 */
export function EmptyState({
  icone,
  titulo,
  texto,
  acao,
  className,
}: {
  icone?: LucideIcon | undefined
  titulo: string
  texto?: string | undefined
  acao?: React.ReactNode | undefined
  className?: string | undefined
}) {
  return (
    <div className={cn('du-vazio', className)}>
      {icone ? <Icone de={icone} tamanho={48} cor="marca" /> : null}
      <h3 className="du-vazio__titulo">{titulo}</h3>
      {texto ? <p className="du-vazio__texto">{texto}</p> : null}
      {acao ? <div className="du-vazio__acao">{acao}</div> : null}
    </div>
  )
}
